module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "header0601",
      "epub:type": "chapter",
      "id": "ch06",
      "role": "doc-chapter"
    }
  }, [_c('header', {
    attrs: {
      "id": "header0601"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiseneca0005#rch06"
    }
  }, [_vm._v("Letter 6")])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("Intimacy within friendship")]), _vm._v(" "), _c('h1', {
    staticClass: "cs",
    attrs: {
      "role": "doc-subtitle"
    }
  }, [_vm._v("From Seneca to Lucilius")]), _vm._v(" "), _c('h1', {
    staticClass: "cs",
    attrs: {
      "role": "doc-subtitle"
    }
  }, [_vm._v("Greetings")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c6p1",
      "id": "c6p1r",
      "role": "doc-noteref"
    }
  }, [_vm._v("1")])])]), _vm._v(" My understanding is, Lucilius, that what is happening in me is not merely a removal of flaws, but a transformation.* Not that there is nothing left in me to be amended! At this point I don’t promise that, nor do I expect it. Why should I not have many characteristics to sort through and either reduce or heighten? This is itself an indication that the mind has reached a better place, when it perceives faults in itself that previously went unrecognized. With some patients, it is cause for congratulation when they realize that they are ill.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "9",
      "id": "p9",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "pnum"
  }, [_vm._v("2")]), _vm._v(" If only I "), _c('i', [_vm._v("could")]), _vm._v(" share such a sudden transformation with you—that’s what I would like. In that case, I would begin to have more confidence in our friendship. For it would then be true friendship, such as no hope, no fear, no self-interest can sever. That is a friendship that stays with people until they die—and that people die for. "), _c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c6p3",
      "id": "c6p3r",
      "role": "doc-noteref"
    }
  }, [_vm._v("3")])])]), _vm._v(" I can name you many people who have friends and yet are without friendship; this is not the case, though, where equal willingness draws minds into a companionship of honorable intentions.* How could it be? For they know that everything they have is held in common, and especially their trials.")]), _vm._v(" "), _c('p', [_vm._v("You cannot imagine how much progress I see myself making every day. "), _c('span', {
    staticClass: "pnum"
  }, [_vm._v("4")]), _vm._v(" “What remedies are these that have done so much for you?” you say. “Send them to me too!” Indeed, I am longing to shower you with all of them. What gives me pleasure in learning something is that I can teach it. Nothing will ever please me, not even what is remarkably beneficial, if I have learned it for myself only. If wisdom were given to me with this proviso, that I should keep it shut up in myself and never express it to anyone else, I should refuse it. No good is enjoyable to possess without a companion. "), _c('span', {
    staticClass: "pnum"
  }, [_vm._v("5")]), _vm._v(" So I will send you the books themselves; and I will annotate them too, so that you need not expend much effort hunting through them for the profitable bits, but can get right away to the things that I endorse and am impressed with.")]), _vm._v(" "), _c('p', [_vm._v("But formal discourse will not do as much for you as direct contact, speaking in person and sharing a meal. You must come and see me face-to-face—first of all, because humans believe their eyes much more than their ears, and second, because learning by precepts is the long way around. The quick and effective way is to learn by example. "), _c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c6p6",
      "id": "c6p6r",
      "role": "doc-noteref"
    }
  }, [_vm._v("6")])])]), _vm._v(" If Cleanthes had "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "10",
      "id": "p10",
      "role": "doc-pagebreak"
    }
  }), _vm._v("merely listened to Zeno, he would not have been molded by him; instead, he made himself a part of Zeno’s life, looking into his inmost thoughts and seeing whether he lived in accordance with his own rule.* Plato and Aristotle and the whole crowd of philosophers who would later go their separate ways all derived more from Socrates’s conduct than from his words. Metrodorus, Hermarchus, and Polyaenus were made great men not by Epicurus’s formal instruction but by living together with him.* Nor do I summon you to me only for your own benefit. It is for my benefit as well: each of us has much to bestow on the other.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c6p7",
      "id": "c6p7r",
      "role": "doc-noteref"
    }
  }, [_vm._v("7")])])]), _vm._v(" Meanwhile, as I owe you the daily dole, I will tell you what pleased me today in the writings of Hecaton:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("Do you ask what progress I have made? I have begun to be a friend to myself.*")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Valuable progress indeed: he will never be alone. Believe me, such a person will be a friend to everyone.")]), _vm._v(" "), _c('p', [_vm._v("Farewell.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5951648","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-seneca-0012.vue
// module id = 87
// module chunks = 0